import { Box, Button, Container, TextField, Typography } from "@mui/material";

import EmailIcon from "@mui/icons-material/Email";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneIcon from "@mui/icons-material/Phone";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

import { useEffect, useState } from "react";
import contactHeroBg from "../../assets/images/contact_hero_bg.png";
import contactFormBg from "../../assets/images/contactFormBg.png";
import Alert from "@mui/material/Alert";
import Collapse from "@mui/material/Collapse";

export default function ContactHero() {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    postalCode: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  useEffect(() => {
    if (error || success) {
      const timer = setTimeout(() => {
        setError("");
        setSuccess("");
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [error, success]);

const handleChange = (e) => {
  const { name, value } = e.target;

  if (name === "phone") {
    setFormData((prev) => ({
      ...prev,
      phone: formatPhoneNumber(value),
    }));
  } else {
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  }

  setError("");
  setSuccess("");
};

  const formatPhoneNumber = (value) => {
    // Keep only digits
    const digits = value.replace(/\D/g, "").substring(0, 10);

    const length = digits.length;

    if (length === 0) return "";
    if (length < 4) return `(${digits}`;
    if (length < 7) return `(${digits.substring(0, 3)}) ${digits.substring(3)}`;

    return `(${digits.substring(0, 3)}) ${digits.substring(
      3,
      6,
    )}-${digits.substring(6, 10)}`;
  };

  const validateForm = () => {
    setError("");

    if (
      !formData.fullName.trim() ||
      !formData.email.trim() ||
      !formData.phone.trim() ||
      !formData.postalCode.trim() ||
      !formData.message.trim()
    ) {
      setError(
        "Please complete all required fields before submitting your request.",
      );
      return false;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

    if (!emailRegex.test(formData.email.trim())) {
      setError("Please enter a valid email address.");
      return false;
    }

    const phoneRegex = /^\([2-9][0-9]{2}\)\s[2-9][0-9]{2}-[0-9]{4}$/;

    if (!phoneRegex.test(formData.phone)) {
      setError("Please enter a valid phone number.");
      return false;
    }

    const postalRegex =
      /^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][ -]?\d[ABCEGHJ-NPRSTV-Z]\d$/i;

    if (!postalRegex.test(formData.postalCode.trim())) {
      setError("Please enter a valid postal code.");
      return false;
    }

    if (formData.message.trim().length < 10) {
      setError("Please provide a few more details about your request.");
      return false;
    }

    return true;
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    setError("");
    setSuccess("");

    if (!validateForm()) return;

    setLoading(true);

    try {
      const body = {
        access_key: "f7ee36f3-b2e2-45d2-b351-8ddc08e351e5",
        subject: `New Quote Request | ${formData.fullName}  | Comet Cleaners`,
        from_name: "Comet Cleaners Website",
        name: formData.fullName,
        email: formData.email,
        phone: formData.phone,
        postalCode: formData.postalCode,
        message: formData.message,
      };

      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(body),
      });

      const result = await response.json();

      if (result.success) {
        setSuccess(
          "Thank you! Your quote request has been received. Our team will contact you shortly.",
        );

        setFormData({
          fullName: "",
          email: "",
          phone: "",
          postalCode: "",
          message: "",
        });
      } else {
        setError("Something went wrong. Please try again.");
      }
    } catch (err) {
      setError(
        "We couldn't submit your request at the moment. Please try again later.",
      );
    }

    setLoading(false);
  };

  return (
    <Box
      sx={{
        py: {
          xs: 4,
          md: 6,
        },

        backgroundImage: ` url(${contactHeroBg}) `,

        backgroundSize: "cover",

        backgroundPosition: "center",

        backgroundRepeat: "no-repeat",

        overflow: "hidden",
      }}
    >
      <Container maxWidth="xl">
        <Box
          sx={{
            display: "flex",

            flexDirection: {
              xs: "column",
              lg: "row",
            },

            gap: {
              xs: 4,
              md: 6,
            },

            alignItems: "center",
          }}
        >
          {/* LEFT */}

          <Box
            sx={{
              flex: 1,
            }}
          >
            <Box
              sx={{
                display: "inline-flex",

                px: 2.5,

                py: 1,

                borderRadius: "50px",

                background: "rgba(0,87,255,.08)",

                color: "#0057FF",

                fontSize: "12px",

                fontWeight: 800,

                letterSpacing: "1px",

                textTransform: "uppercase",
              }}
            >
              Contact Us
            </Box>

            <Typography
              sx={{
                mt: 2,

                fontWeight: 900,

                lineHeight: 1.05,

                color: "#07122F",

                fontSize: {
                  xs: "32px",
                  sm: "32px",
                  md: "56px",
                  lg: "56px",
                },
              }}
            >
              Let's Discuss
              <br />
              <Box
                component="span"
                sx={{
                  background: "linear-gradient(135deg,#0057FF,#1DB6FF)",

                  WebkitBackgroundClip: "text",

                  WebkitTextFillColor: "transparent",
                }}
              >
                Your Laundry Needs
              </Box>
            </Typography>

            <Typography
              sx={{
                mt: 3,

                color: "#64748B",

                maxWidth: "600px",

                lineHeight: 1.9,

                fontSize: {
                  xs: "13px",
                  sm: "14px",
                  md: "16px",
                },
              }}
            >
              Need professional dry cleaning, laundry or garment care services?
              Our team is ready to help.
            </Typography>

            {/* CONTACT INFO */}

            <Box
              sx={{
                mt: 4,

                display: "flex",

                flexDirection: "column",

                gap: 2,
              }}
            >
              {[
                {
                  icon: <PhoneIcon />,
                  text: "+19054283542",
                },
                {
                  icon: <EmailIcon />,
                  text: "cometcleaners5@gmail.com",
                },
                {
                  icon: <LocationOnIcon />,
                  text: "15 Westney Rd N, Unit 4A, Ajax, ON L1T 1P5",
                },
              ].map((item, index) => (
                <Box
                  key={index}
                  sx={{
                    display: "flex",

                    alignItems: "center",

                    gap: 2,
                  }}
                >
                  <Box
                    sx={{
                      width: 46,

                      height: 46,

                      borderRadius: "14px",

                      display: "flex",

                      alignItems: "center",

                      justifyContent: "center",

                      color: "#fff",

                      background: "linear-gradient(135deg,#0057FF,#1DB6FF)",
                    }}
                  >
                    {item.icon}
                  </Box>

                  <Typography
                    sx={{
                      fontWeight: 600,

                      color: "#12305F",
                    }}
                  >
                    {item.text}
                  </Typography>
                </Box>
              ))}
            </Box>

            {/* BUTTON */}

            <Button
              startIcon={<WhatsAppIcon />}
              href="https://wa.me/+19054283542"
              target="_blank"
              component="a"
              sx={{
                mt: 4,

                px: 4,

                py: 1.8,

                borderRadius: "50px",

                background: "linear-gradient(135deg,#25D366,#1EBE5D)",

                color: "#fff",

                fontWeight: 800,

                textTransform: "none",

                boxShadow: "0 15px 35px rgba(37,211,102,.25)",

                "&:hover": {
                  transform: "translateY(-3px)",

                  background: "linear-gradient(135deg,#25D366,#1EBE5D)",
                },
              }}
            >
              Chat On WhatsApp
            </Button>
          </Box>

          {/* RIGHT FORM */}

          <Box
            sx={{
              flex: 1,

              width: "100%",
            }}
          >
            <Box
              sx={{
                position: "relative",

                overflow: "hidden",

                p: {
                  xs: 2.5,
                  md: 4,
                },

                borderRadius: {
                  xs: "24px",
                  md: "32px",
                },

                backgroundImage: `
    //   linear-gradient(
    //   rgba(255,255,255,.94),
    //   rgba(248,251,255,.88)
    //   ),
      url(${contactFormBg})
    `,

                backgroundSize: "cover",

                backgroundPosition: "center",

                border: "1px solid rgba(255,255,255,.9)",

                backdropFilter: "blur(18px)",

                boxShadow:
                  "0 25px 60px rgba(0,87,255,.08), inset 0 1px 0 rgba(255,255,255,.9)",

                // "&::before": {
                //   content: '""',

                //   position: "absolute",

                //   left: 0,

                //   top: 30,

                //   bottom: 30,

                //   width: "5px",

                //   borderRadius: "20px",

                //   background: "linear-gradient(180deg,#0057FF,#1DB6FF)",
                // },
              }}
            >
              {/* HEADING */}

              <Typography
                sx={{
                  fontWeight: 900,

                  color: "#07122F",

                  fontSize: {
                    xs: "24px",
                    md: "32px",
                  },

                  mb: 1,
                }}
              >
                Request A Free Quote
              </Typography>

              <Typography
                sx={{
                  color: "#64748B",

                  fontSize: "14px",

                  mb: 3,
                }}
              >
                Fill out the form below and our team will contact you shortly.
              </Typography>

              {/* FORM */}

              <Box
                component="form"
                onSubmit={handleSubmit}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 2,
                }}
              >
                <Collapse in={Boolean(error)}>
                  <Alert
                    severity="error"
                    sx={{
                      mb: 2,
                      borderRadius: 2,
                      fontWeight: 500,
                    }}
                  >
                    {error}
                  </Alert>
                </Collapse>

                <Collapse in={Boolean(success)}>
                  <Alert
                    severity="success"
                    sx={{
                      mb: 2,
                      borderRadius: 2,
                      fontWeight: 500,
                    }}
                  >
                    {success}
                  </Alert>
                </Collapse>
                <TextField
                  label="Full Name"
                  name="fullName"
                  value={formData.fullName}
                  onChange={handleChange}
                  placeholder="John Smith"
                  fullWidth
                />

                <TextField
                  label="Email Address"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="john@example.com"
                  fullWidth
                />

                <TextField
                  fullWidth
                  name="phone"
                  label="Phone Number"
                  placeholder="(905) 555-1234"
                  value={formData.phone}
                  onChange={handleChange}
                  inputProps={{
                    maxLength: 14,
                    inputMode: "numeric",
                  }}
                />

                <TextField
                  label="Postal Code"
                  name="postalCode"
                  value={formData.postalCode}
                  onChange={handleChange}
                  placeholder="L1S 0A1"
                  fullWidth
                />

                {/* <TextField
                  fullWidth
                  select
                  label="Service Needed"
                  SelectProps={{
                    native: true,
                  }}
                >
                  <option value="">Select Service</option>

                  <option>Dry Cleaning</option>

                  <option>Laundry Service</option>

                  <option>Shoe Cleaning</option>

                  <option>Wedding Dress Cleaning</option>

                  <option>Uniform Cleaning</option>

                  <option>Pickup & Delivery</option>
                </TextField> */}

                <TextField
                  label="Message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  multiline
                  rows={4}
                  placeholder="Tell us about your garments or cleaning requirements..."
                  fullWidth
                />

                <Button
                  type="submit"
                  variant="contained"
                  disabled={loading}
                  sx={{
                    height: { xs: 52, md: 58 },
                    borderRadius: "18px",
                    fontWeight: 800,
                    fontSize: "15px",
                    textTransform: "none",
                    background: "linear-gradient(135deg,#0057FF,#1DB6FF)",
                    "&:hover": {
                      background: "linear-gradient(135deg,#0057FF,#1DB6FF)",
                    },
                  }}
                >
                  {loading ? "Submitting..." : "Get My Free Quote"}
                </Button>
              </Box>
            </Box>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
